export const convertUtcToAmPm = (timestamp) => {
    if(!timestamp) return '';
    
    // Create a Date object from the UTC timestamp
    let date = new Date(`1970-01-01T${timestamp}`);

    // Get hours and minutes
    let hours = date.getUTCHours();
    let minutes = date.getUTCMinutes();

    // Determine AM/PM
    let period = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight

    // Format hours and minutes with leading zeros if necessary
    let formattedTime = `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;

    return formattedTime;
};